import { Component, HostBinding, Input, OnInit } from "@angular/core";
import { UIRouterGlobals } from "@uirouter/core";
import { GetStartedModalService } from "../get-started-modal/get-started-modal.service";
import { ProjectDigestsService } from "../models/project-digests.service";
import { PlanTierService } from "../plan-tier/plan-tier.service";
import { InstructionsModalService } from "../project-detail/instructions-modal/instructions-modal.service";
import { RememberService } from "../remember/remember.service";
import { SendDataModalService } from "../send-data-modal/send-data-modal.service";
import { UpgradeModalService } from "../upgrade-modal/upgrade-modal.service";
import { sampleDigests } from "./sample-data/digests";

@Component({
  selector: "ab-project-trends",
  templateUrl: "./project-trends.component.html",
})
export class ProjectTrendsComponent implements OnInit {
  @HostBinding("class") public hostClass = "d-flex flex-column flex-grow-1 row";
  @Input() public emptyProject: boolean;
  @Input() public project: any;
  @Input() public user: any;
  @Input() public missingErrorData: boolean;
  @Input() public missingDeployData: boolean;
  @Input() public missingPerformanceData: boolean;

  public digests: any[];
  public selectedDigest: any;
  public featureDisabled: boolean;
  public showEmailDigestSubscriptionBtn: boolean;
  public projectIsMissingAnyData: boolean;

  constructor(
    private $uiRouterGlobals: UIRouterGlobals,
    private getStartedModalService: GetStartedModalService,
    private instructionsModalService: InstructionsModalService,
    private projectDigestsService: ProjectDigestsService,
    private planTierService: PlanTierService,
    private rememberService: RememberService,
    private sendDataModalService: SendDataModalService,
    private upgradeModal: UpgradeModalService,
  ) {}

  public ngOnInit() {
    window.document.title = `${this.project.name} trends`;
    this.showEmailDigestSubscriptionBtn = false;
    if (
      this.missingErrorData &&
      this.missingDeployData &&
      this.missingPerformanceData &&
      !this.sendingDemoData()
    ) {
      this.modalService().open();
    }

    this.planTierService.features().subscribe((features: any) => {
      this.featureDisabled = !features.trends_dashboard;

      if (this.featureDisabled) {
        this.digests = sampleDigests;
        this.selectedDigest = this.digests[0];
      } else {
        // User is not subscribed to any digest emails if user.digestEmails is 0.
        this.showEmailDigestSubscriptionBtn = this.user.digestEmails === 0;

        this.projectIsMissingAnyData =
          this.missingErrorData ||
          this.missingDeployData ||
          this.missingPerformanceData;

        this.projectDigestsService
          .get({
            projectId: this.project.id,
          })
          .subscribe((data: any) => {
            this.digests = data;
            this.selectedDigest = this.selectDigest(this.digests);
          });
      }
    });
  }

  public trackBy(_index: number, digest: any) {
    return digest.id;
  }

  public openUpgradeModal($event: any) {
    this.upgradeModal.open($event);
  }

  private modalService() {
    if (
      this.project.isFirstProject &&
      !this.project.demoModeUntilDate &&
      !this.rememberService.get("sendDataModalDismissed")
    ) {
      return this.sendDataModalService;
    }

    if (this.rememberService.get("getStartedModalDismissed")) {
      return this.instructionsModalService;
    }

    return this.getStartedModalService;
  }

  private selectDigest(digests: any[]) {
    const digestIdParam = this.$uiRouterGlobals.params.digestId;
    if (!digestIdParam) {
      return digests[0];
    }

    for (const digest of digests) {
      if (digest.id === digestIdParam) {
        return digest;
      }
    }

    return digests[0];
  }

  private sendingDemoData(): boolean {
    if (!this.project.demoModeUntilDate) {
      return false;
    }

    return new Date() < new Date(this.project.demoModeUntilDate);
  }
}
